// extracted by mini-css-extract-plugin
export var backgroundStars = "mailus-module--backgroundStars--ca990";
export var bottom_gradient = "mailus-module--bottom_gradient--1784b";
export var container = "mailus-module--container--21fa8";
export var footer_container = "mailus-module--footer_container--697b2";
export var logoEffect = "mailus-module--logoEffect--592aa";
export var titleWrapper = "mailus-module--titleWrapper--47b5b";
export var wrapper = "mailus-module--wrapper--1325e";